module.exports = __webpack_public_path__ + "static/media/abb_error-circle-1_16.a163801c.svg";